import validate from '@baza/helpers/validate';

export default {
    data() {
        return {
            status: 'normal',
            form: {
                phone: {
                    value: '',
                    require: true,
                    error: false,
                    type: 'phone',
                    errorType: 'require',
                    errorText: 'Обязательное поле',
                },
                name: {
                    value: '',
                    require: true,
                    error: false,
                    type: 'text',
                    errorType: 'require',
                    errorText: 'Обязательное поле',
                },
                comment: {
                    value: '',
                    require: true,
                    error: false,
                    type: 'text',
                    errorType: 'require',
                },
            },
        };
    },
    methods: {
        validate() {
            let result = true;
            for (const f in this.form) {
                let error = false;
                if (this.form[f].require) {
                    switch (this.form[f].type) {
                    case 'text':
                        if (!this.validateText(this.form[f].value, this.form[f].rule)) {
                            error = true;
                            result = false;
                        }
                        break;
                    case 'phone':
                        if (((this.form[f].validateNotEmpty && this.form[f].value.length > 0)
                            || this.form[f].require) && !validate.isPhoneCity(this.form[f].value)) {
                            if (!validate.isPhoneCity(this.form[f].value) && this.form[f].value.length > 0) {
                                this.form[f].errorText = 'Некорректный номер, введите в формате +7(9ХХ)ХХХ-ХХ-ХХ';
                            } else {
                                this.form[f].errorText = 'Обязательное поле';
                            }
                            error = true;
                            result = false;
                        }
                        break;
                    default:
                        break;
                    }
                    if (error) {
                        this.setError(f);
                    }
                }
            }
            return result;
        },
        setError(f) {
            if (this.form[f].error) {
                setTimeout(() => {
                    this.form[f].error = false;
                }, 50);
                setTimeout(() => {
                    this.form[f].error = true;
                    setTimeout(() => {
                        this.form[f].error = false;
                        setTimeout(() => {
                            this.form[f].error = true;
                        }, 250);
                    }, 250);
                }, 250);
            } else {
                this.form[f].error = true;
            }
        },
        validateText(value, rule) {
            let result = true;
             if (!rule || (typeof rule === 'object' && Object.keys(rule).length === 0)) {
                result = (!(!value || value.toString().length === 0));
            }
            if (typeof rule === 'object' && Object.keys(rule).length > 0) {
                if (rule.minLength && value.toString().length < rule.minLength) {
                    result = false;
                }
                if (rule.maxLength && value.toString().length > rule.maxLength) {
                    result = false;
                }
            }
            return result;
        },
        callback(r) { return r; },
    },

};
